import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment, ProductionEnvironmentName } from './environments/environment';

if (environment.ENVIRONMENT_NAME === ProductionEnvironmentName) {
    enableProdMode();
}

const idle = (callback: () => void) => {
    const ric = (window as any).requestIdleCallback;
    return ric ? ric(callback, { timeout: 2000 }) : setTimeout(callback, 200);
};

const afterFirstPaint = () =>
    new Promise<void>((resolve) => {
        requestAnimationFrame(() => setTimeout(resolve, 16));
    });

async function startApplication() {
    await afterFirstPaint();

    const appRef = await bootstrapApplication(AppComponent, appConfig).catch((err) => {
        console.error(err);
        throw err;
    });

    idle(async () => {
        try {
            await Promise.allSettled([
                import('./app/pages/downloads/downloads-page.component'),
                import('./app/pages/nodes/nodes-page.component'),
                import('./app/pages/requirements/requirements-page.component'),
                import('./app/pages/docs/docs-page.component'),
            ]);
        }
        catch (error) {
            console.warn('Prefetch failed', error);
        }
    });

    return appRef;
}

startApplication();
